//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {moveToOtherDB} from '../db-utils.js';

export default {
  data() {
    return {
      showDialog: false,
      movedItem: null,
      // Md-select complains when used with full objects.
      targetDBname: null,
      availableDBs: {},
    };
  },
  methods: {
    save() {
      moveToOtherDB(
        this.movedItem,
        this.availableDBs[this.targetDBname],
        this.$reactiveCache)
    },
  },
  mounted() {
    this.$root.$on('share-dialog', data => {
      this.showDialog = true
      this.movedItem = data.item
      // For some reason I was getting errors when I tried to access
      // $sessionState.dbs directly, so I pass them as a parameter.
      this.availableDBs = data.dbs
      this.targetDBname = this.movedItem.couch.name
    });
  },
};
